import store from '~/vuestrap/vuexstore'
import { routes, guards, make } from '~/vuestrap/router'
import ready from './guards/ready'

const extraGuards = {
  ready,
}

guards(routes, store, extraGuards)

const router = make(routes, { mode: 'history' })

export default router
